module.exports = __webpack_public_path__ + "img/icon-black.0b24ca51.png";